import "../scss/index.scss";

console.log("hagsteel.com 0.1");

const toggles = document.querySelectorAll(".toggle-nav");

for (let i = 0; i < toggles.length; i ++) {
  let el = toggles[i];
  el.addEventListener("click", (e) => {
    e.preventDefault();
    let currentClasses = document.getElementById("sidebar").className;
    if (currentClasses == "sidebar") {
      document.cookie = "togglestate=1";
      shrinkSidebar();
    } else {
      document.cookie = "togglestate=0";
      expandSidebar();
    }
  });
}

function expandSidebar() {
    document.getElementById("sidebar").className = "sidebar";
    document.getElementById("main-content").className = "content";
}

function shrinkSidebar() {
    document.getElementById("sidebar").className = "sidebar shrink";
    document.getElementById("main-content").className = "content expand";
}

function loadSidebarState() {
  console.log(document.cookie.indexOf("togglestate=1"));
  if (document.cookie.indexOf("togglestate=0") > -1) {
    expandSidebar();
  } else {
    shrinkSidebar();
  }
}

loadSidebarState();


// -----------------------------------------------------------------------------
// 		- Revemail -
// -----------------------------------------------------------------------------

const createMailEl = () => {
  let mailEl = document.createElement("a");
  mailEl.setAttribute("href", "mailto:hagstedt@gmail.com");
  mailEl.innerHTML = "hagstedt@gmail.com";
  //mailEl.className = "revemail revemail-inverted";
  return mailEl;
};

const showMailButton = () => {
  let showMailEl = document.createElement("a");
  showMailEl.setAttribute("href", "#");
  showMailEl.innerHTML = "reveal email";
  showMailEl.addEventListener("click", (e) => {
    let revemailEl = document.querySelector(".revemail");
    revemailEl.parentNode.replaceChild(createMailEl(), revemailEl);
    e.preventDefault();
  });

  return showMailEl;
};

const revemail = document.querySelector(".revemail");
if (revemail) {
  let mailEl = showMailButton();
  revemail.append(mailEl);
}
